import { render, staticRenderFns } from "./TeacherData.vue?vue&type=template&id=05e4bbfa&"
import script from "./TeacherData.vue?vue&type=script&lang=ts&"
export * from "./TeacherData.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherData.vue?vue&type=style&index=0&id=05e4bbfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports